// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".link-wrapper[data-v-17bd528c] {\n  display: block;\n  width: 100%;\n  overflow: hidden;\n  margin-top: 5px;\n}\n.link[data-v-17bd528c] {\n  color: #00f;\n  text-decoration: underline;\n}\n.inset[data-v-17bd528c] {\n  margin-left: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
